export default "__VITE_ASSET__D66vf8KK__"